<div class="seat-map-container">
  <!-- Información del vagón -->
  <div class="seat-map-header">
    <h3 class="seat-map-title">{{ tipoTicket.nombre_localidad }}</h3>
    @if (tipoTicket.seatmap) {
      <!-- <p class="seat-map-subtitle">
        {{ tipoTicket.seatmap.rows }} filas × {{ tipoTicket.seatmap.cols }} columnas
      </p> -->
    }
  </div>

  <!-- Mapa de asientos -->
  @if (seatMatrix().length > 0) {
    <div class="seat-map-grid">
      <!-- Indicador de dirección superior (Frente) -->
      @if (tipoTicket.seatmap?.frontLabel) {
        <!-- <div class="direction-label direction-label-top">
          ⬆️ {{ tipoTicket.seatmap?.frontLabel }}
        </div> -->
      }

      <!-- Filas de asientos -->
      @for (row of seatMatrix(); track $index; let rowIndex = $index) {
        <div class="seat-row">
          <!-- Asientos de la fila -->
          @for (seat of row; track $index; let colIndex = $index) {
            @if (isEmptySpace(seat)) {
              <!-- Espacio vacío -->
              <div class="seat-empty"></div>
            } @else {
              <!-- Asiento -->
              <div
                class="seat-wrapper"
                [class.cursor-pointer]="seat!.status === 'available' || isSeatSelected(seat!)"
                [class.cursor-not-allowed]="seat!.status === 'blocked'"
                [attr.data-direction]="seat!.ticket.direction"
                (click)="onSeatClick(seat!)">
                <img
                  [src]="getSeatImageSrc(seat!)"
                  [alt]="'Asiento ' + getSeatLabel(seat!)"
                  [class]="getSeatClasses(seat!)"
                  [class.direction-front]="seat!.ticket.direction === 'front'"
                  [class.direction-back]="seat!.ticket.direction === 'back'"
                  [class.direction-left]="seat!.ticket.direction === 'left'"
                  [class.direction-right]="seat!.ticket.direction === 'right'"
                  class="seat-image" />
                <span class="seat-label">{{ getSeatLabel(seat!) }}</span>
              </div>
            }
          }
        </div>
      }

      <!-- Indicador de dirección inferior (Atrás) -->
      @if (tipoTicket.seatmap?.backLabel) {
        <!-- <div class="direction-label direction-label-bottom">
          ⬇️ {{ tipoTicket.seatmap?.backLabel }}
        </div> -->
      }
    </div>
  } @else {
    <div class="no-seatmap">
      <p>No hay mapa de asientos configurado para este vagón.</p>
    </div>
  }

  <!-- Resumen de selección (sin precio todavía) -->
  @if (selectionSummary().count > 0) {
    <div class="selection-summary">
      <div class="summary-info">
        <h4 class="summary-title">Selección actual</h4>
        <p class="summary-details">
          <strong>{{ selectionSummary().count }}</strong> asiento(s) seleccionado(s)
        </p>
        @if (selectedPrice) {
          <p class="summary-total">
            Total: <strong>${{ selectionSummary().total.toFixed(2) }}</strong>
          </p>
        } @else {
          <p class="text-sm text-gray-600">
            Selecciona un precio para ver el total
          </p>
        }
      </div>
      <div class="summary-actions">
        <button
          type="button"
          class="btn-clear-selection"
          (click)="clearSelection()">
          Limpiar selección
        </button>
      </div>
    </div>
  }
</div>


